import { FC, ReactElement, useMemo } from 'react';

import { isInStock } from '../../entities/@products/Product/ProductHelpers';
import { useTrans } from '../../hooks';
import { IconButton } from '../@buttons/IconButton/IconButton';
import { WishlistButton } from '../@buttons/WishlistButton/WishlistButton';

import './ProductCallToAction.scss';

interface ProductCallToActionProps {
    cartIsLoading: boolean;
    wishlistIsLoading: boolean;
    isInWishlist: boolean;
    stockQuantity: number;
    inCartQuantity: number;
    onAddToCart: () => void;
    onWishlistButtonClick: () => void;
    className?: string;
}

export const ProductCallToAction: FC<ProductCallToActionProps> = ({
    cartIsLoading,
    wishlistIsLoading,
    isInWishlist,
    stockQuantity,
    inCartQuantity,
    onAddToCart,
    onWishlistButtonClick,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const inStock = useMemo((): boolean => isInStock(stockQuantity, inCartQuantity), [stockQuantity, inCartQuantity]);

    return (
        <div className={`product-call-to-action ${className}`}>
            <IconButton
                icon="cart"
                disabled={!inStock || cartIsLoading}
                text={trans(`common.${inStock ? 'addToCart' : 'soldOut'}`)}
                onClick={onAddToCart}
                className="product-call-to-action__cart-button"
            />

            <WishlistButton
                isActive={isInWishlist}
                disabled={wishlistIsLoading}
                text={isInWishlist ? trans('common.removeFromWishlist') : trans('common.addToWishlist')}
                onClick={onWishlistButtonClick}
                className="product-call-to-action__wishlist-button"
            />
        </div>
    );
};
